class CartLocalStorageServiceClass {
  constructor() {
    this.cartUUID = $("#CART_UUID").val();
  }

  getCart() {
    const cart = localStorage.getItem(`cart-${this.cartUUID}`);
    return cart ? JSON.parse(cart) : [];
  }

  setCart(cartData) {
    if (this.cartUUID) {
      localStorage.setItem(`cart-${this.cartUUID}`, JSON.stringify(cartData));
    }
  }

  setCartLastUpdate() {
    if (this.cartUUID) {
      localStorage.setItem(`cart-${this.cartUUID}-last-update`, Date.now());
    }
  }

  getCartLastUpdate() {
    const timestamp = localStorage.getItem(`cart-${this.cartUUID}-last-update`);
    return timestamp ? JSON.parse(timestamp) : 0;
  }

  deleteCart(){
    const removeList = [];
    for (let i=0, len = localStorage.length; i < len; i++) {
      const key = localStorage.key(i);
      if (key.includes(this.cartUUID)) {
        removeList.push(key);
      }
    }

    removeList.forEach(key => localStorage.removeItem(key));
    this.cartUUID = null;
  }
}

export const cartLocalStorageService = new CartLocalStorageServiceClass();
